"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNextFocusableElement = exports.getFocusableElements = void 0;
const getFocusableElements = (refOrElement) => refOrElement
    ? Array.from(refOrElement.querySelectorAll('button:not([disabled]), a:not([tabindex="-1"]), video, input, select, textarea, [tabindex]:not([tabindex="-1"]), [contenteditable]'))
    : [];
exports.getFocusableElements = getFocusableElements;
const getNextFocusableElement = (context, direction) => {
    if (context) {
        const focusableItems = (0, exports.getFocusableElements)(context);
        const activeIndex = document.activeElement
            ? focusableItems.indexOf(document.activeElement)
            : -1;
        const defaultIndex = direction > 0 ? 0 : focusableItems.length - 1;
        const nextIndex = activeIndex + direction;
        const isNoNextIndex = activeIndex === -1 ||
            (direction > 0 ? nextIndex > focusableItems.length - 1 : nextIndex < 0);
        const nextElementIndex = isNoNextIndex ? defaultIndex : nextIndex;
        return focusableItems[nextElementIndex] || focusableItems[defaultIndex];
    }
    return null;
};
exports.getNextFocusableElement = getNextFocusableElement;
//# sourceMappingURL=getNextFocusableElement.js.map